import { useTranslation } from 'react-i18next';

import type { SubmittedInvoice } from '~/api/invoices/types';

import { InfoBlock, Text } from '~/components';
import { ClientCard, CopyrightCard } from '~/features/documents';
import { useIntl } from '~/hooks/useIntl';

import { datesStyle, termsStyle, wrapperStyle } from './InvoiceInfo.css';

type Props = {
  invoice: SubmittedInvoice;
};

export const InvoiceInfo = ({ invoice }: Props) => {
  const { formatDate } = useIntl();
  const { t } = useTranslation(['invoices']);

  return (
    <div className={wrapperStyle}>
      <div className={datesStyle}>
        <InfoBlock label={t('invoices:overview.columns.date')}>
          <Text>{formatDate(invoice.documentDate)}</Text>
        </InfoBlock>

        <InfoBlock label={t('invoices:overview.columns.dueDate')}>
          <Text>{formatDate(invoice.dueDate)}</Text>
        </InfoBlock>

        <InfoBlock label={t('invoices:fields.entryNumber.label')}>
          <Text>{invoice.fcEntryNumber}</Text>
        </InfoBlock>
      </div>

      {!!invoice.description && (
        <InfoBlock label={t('invoices:fields.description.label')}>
          <Text>{invoice.description}</Text>
        </InfoBlock>
      )}

      <div className={termsStyle}>
        <InfoBlock label={t('invoices:details.copyright.label')}>
          <CopyrightCard
            conditionId={invoice.conditionId}
            customAgreementId={invoice.customAgreementId}
            customConditionId={invoice.customConditionId}
            specialConditions={invoice.specialConditions}
          />
        </InfoBlock>

        <InfoBlock label={t('invoices:fields.clientId.label')}>
          <ClientCard clientId={invoice.clientId} contactId={invoice.contactId} />
        </InfoBlock>
      </div>
    </div>
  );
};
